// node_modules
import React, {useContext, useEffect} from 'react'
import { useSelector } from "react-redux";
import { format, parse } from "date-fns";
import {ToastContext} from '../../App'

// redux
import { useGetOrdersHistoryQuery } from "../../redux/services/order";

// styles
import * as styles from "./OrderStatusPage.module.css";

const OrderStatusPage = () => {
  const uuid = localStorage.getItem("uuid");
  const orders = useSelector((state) => state.orders.orders);
  const showToast = useContext(ToastContext);
  const [showHistory, setShowHistory] = React.useState(false);

  const { data: ordersHistory, isSuccess: isGetOrdersHistorySuccess, isError: isGetOrdersHistoryError } =
    useGetOrdersHistoryQuery({
      userId: uuid,
    });

  useEffect(() => {
    if(isGetOrdersHistoryError) {
      showToast("error", "Order Status", "Unable to load order history");
    }
  }, [isGetOrdersHistoryError])
  
  return (
    <div className={styles.pageWrapper}>
      <h1>YOUR ORDERS</h1>
      <div className={styles.divider}>
        <p>TODAY</p>
        <div />
      </div>
      <div className={styles.ordersContainer}>
        {orders?.length &&
          orders?.map((order) => {
            return (
              <div className={styles.orderCard}>
                <div>
                  <div
                    className={`${styles.cardHeader} ${
                      order.completed ? styles.completed : ""
                    }`}
                  >
                    <div className={styles.headerRow}>
                      <p>
                        {format(
                          parse(
                            order.creation_time,
                            "yyyy-MM-dd HH:mm",
                            new Date()
                          ),
                          "hh:mm aa"
                        )}
                      </p>
                      <h2>{order.food_station_name}</h2>
                      {!order.completed && <i className="pi pi-clock"></i>}
                    </div>
                    <div className={styles.status}>
                      {order.completed
                        ? "Your order is ready! Enjoy!"
                        : "Approximate wait time: 10 minutes"}
                    </div>
                  </div>
                  <div></div>
                  <div className={styles.cardDetails}>
                    <div className={styles.row}>
                      <div>Name</div>
                      <div>
                        {order.name} {order.surname}
                      </div>
                    </div>

                    <div className={styles.row}>
                      <div>Dining Option</div>
                      <div>{order.dining_option_name}</div>
                    </div>

                    <div className={styles.row}>
                      <div>Notification Option</div>
                      <div>{order.notification}</div>
                    </div>

                    {order.notification === "email" && (
                      <div className={styles.row}>
                        <div>Email</div>
                        <div>{order.email}</div>
                      </div>
                    )}
                    {order.notification === "sms" && (
                      <div className={styles.row}>
                        <div>Phone</div>
                        <div>{order.phone}</div>
                      </div>
                    )}

                    <div className={`${styles.row} ${styles.allergies}`}>
                      <div>Allergies</div>
                      <div>
                        {order.allergies.map((allergy, index) => {
                          if (index === order.allergies.length - 1) {
                            return allergy;
                          }
                          return allergy + ",";
                        })}
                      </div>
                    </div>

                    {order.menu?.map((item) => (
                      <div className={styles.row}>
                        <div>{item.group_name || "*No menu group*"}</div>
                        <div>
                          {item.options?.map((option, index) => {
                            if (index === item.options.length - 1) {
                              return option.option_name;
                            }
                            return option.option_name + ", ";
                          })}
                        </div>
                      </div>
                    ))}

                    <div className={styles.row}>
                      <div>✍️ Special instructions</div>
                      <div>{order.special_note}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      {isGetOrdersHistorySuccess && !!ordersHistory.length && (
        <div
          className={styles.showHistoryButton}
          onClick={() => setShowHistory(!showHistory)}
        >
          {showHistory ? (
            <>
              <p>HIDE ORDER HISTORY</p>
              <i className="pi pi-angle-up"></i>
            </>
          ) : (
            <>
              <p>SHOW ORDER HISTORY</p>
              <i className="pi pi-angle-down"></i>
            </>
          )}
        </div>
      )}

      {showHistory && ordersHistory && (
        <div>
          {ordersHistory.map((date) => (
            <>
              <div className={styles.divider}>
                <p>
                  {format(parse(date.date, "yyyy-MM-dd", new Date()), "d MMMM")}
                </p>
                <div />
              </div>
              <div className={styles.ordersContainer}>
                {" "}
                {date.orders.map((order) => (
                  <div className={styles.orderCard}>
                    <div>
                      <div
                        className={`${styles.cardHeader} ${
                          order.completed ? styles.completed : ""
                        }`}
                      >
                        <div className={styles.headerRow}>
                          <p>
                            {format(
                              parse(
                                order.creation_time,
                                "yyyy-MM-dd HH:mm",
                                new Date()
                              ),
                              "HH:mm aa"
                            )}
                          </p>
                          <h2>{order.food_station_name}</h2>
                          {!order.completed && <i className="pi pi-clock"></i>}
                        </div>
                        <div className={styles.status}>
                          {order.completed
                            ? "Your order is ready! Enjoy!"
                            : "Approximate wait time: 10 minutes"}
                        </div>
                      </div>
                      <div></div>
                      <div className={styles.cardDetails}>
                        <div className={styles.row}>
                          <div>Name</div>
                          <div>
                            {order.name} {order.surname}
                          </div>
                        </div>

                        <div className={styles.row}>
                          <div>Dining Option</div>
                          <div>{order.dining_option_name}</div>
                        </div>

                        <div className={styles.row}>
                          <div>Notification Option</div>
                          <div>{order.notification}</div>
                        </div>

                        {order.notification === "email" && (
                          <div className={styles.row}>
                            <div>Email</div>
                            <div>{order.email}</div>
                          </div>
                        )}
                        {order.notification === "sms" && (
                          <div className={styles.row}>
                            <div>Phone</div>
                            <div>{order.phone}</div>
                          </div>
                        )}

                        <div className={styles.row}>
                          <div>Allergies</div>
                          <div>
                            {order.allergies.map((allergy, index) => {
                              if (index === order.allergies.length - 1) {
                                return allergy;
                              }
                              return allergy + ",";
                            })}
                          </div>
                        </div>

                        {order.menu?.map((item) => (
                          <div className={styles.row}>
                            <div>{item.group_name || "*No menu group*"}</div>
                            <div>
                              {item.options?.map((option, index) => {
                                if (index === item.options.length - 1) {
                                  return option.option_name;
                                }
                                return option.option_name + ", ";
                              })}
                            </div>
                          </div>
                        ))}

                        <div className={styles.row}>
                          <div>✍️ Special instructions</div>
                          <div>{order.special_note}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderStatusPage;
